import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';
import './cart-delivery-date.js';

/**
 * Cart drawer component
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta =
        installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/* ✅ BDF — Add-ons Add Button Handler */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.bdf-cart-addon-add');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;

  try {
    const sectionIds = [
      ...new Set(
        [...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map((component) => component.dataset.sectionId)
          .filter(Boolean)
      )
    ];

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || 'Could not add item.');
    }

    document.dispatchEvent(
      new CartAddEvent(data, variantId, {
        source: 'product-form-component',
        itemCount: 1,
        sections: data.sections
      })
    );

    if (btn.isConnected) btn.disabled = false;
  } catch (err) {
    console.error('Add-on add failed', err);
    btn.disabled = false;
    alert('Could not add item. Please try again.');
  }
});
